import { useMutation } from "@tanstack/react-query";
import markNoShow from "../../controllers/appointments/mark-no-show";

const useMarkNoShowMutation = () => {
  return useMutation(markNoShow, {});
};

export default useMarkNoShowMutation;
